<form #thisForm="ngForm" *ngIf="canUploadTransfer()" (ngSubmit)="submit()">
  <style>
    label {
      padding-right: 15px;
    }
  </style>
  <h3>Upload de Arquivo (Ordens de transferências)</h3>
  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados do arquivo de upload</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-12">
          <label>Arquivo</label>
          <input
            #thisInput
            type="file"
            name="file"
            data-cy="uploadFile"
            (change)="openFile($event)"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
      </div>
      <div class="actions">
        <input
          type="button"
          value="Upload"
          data-cy="submit"
          class="btn btn-primary"
          [disabled]="!file"
          appDebounceClick
          (debounceClick)="submit()"
          [debounceTime]="200"
        />
      </div>
    </div>
  </div>
</form>

<br />
<mat-toolbar class="text-uppercase">
  <mat-toolbar-row>
    <span>Ordens</span>
  </mat-toolbar-row>
</mat-toolbar>

<div class="table-container">
  <table mat-table [dataSource]="Files" class="col-12">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Nome</th>
      <td mat-cell *matCellDef="let element">
        {{ element.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="createDate">
      <th mat-header-cell *matHeaderCellDef>Data de Criação</th>
      <td mat-cell *matCellDef="let element">
        {{ element.creationDate | date: "dd/MM/yyyy hh:mm:ss" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="createUser">
      <th mat-header-cell *matHeaderCellDef>Usuário de Criação</th>
      <td mat-cell *matCellDef="let element">
        {{ element.creationUser }}
      </td>
    </ng-container>

    <ng-container matColumnDef="workflowStatus">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let element">{{ element.workflowStatus }}</td>
    </ng-container>

    <ng-container matColumnDef="actions" *ngIf="canViewMonitor()" sticky>
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" class="actions">
        <div>
          <a
            (click)="reject(element.id)"
            *ngIf="canApproveUpload() && element.isFinished === false"
          >
            <i
              title="Rejeitar"
              class="fas fa-minus-circle fa-lg"
              style="color: red"
            ></i>
          </a>
          <a
            (click)="approve(element.id)"
            *ngIf="canApproveUpload() && element.isFinished === false"
          >
            <i
              title="Aprovar"
              class="fas fa-check fa-lg"
              style="color: green"
            ></i>
          </a>
          <a (click)="showHistory(element.workflowId)">
            <i
              title="Histórico"
              class="fas fa-history fa-lg"
              style="color: black"
            ></i>
          </a>
          <a (click)="download(element.name)">
            <i
              title="Download"
              class="fas fa-download fa-lg"
              style="color: blue"
            ></i>
          </a>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="ColumnsFile; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: ColumnsFile"></tr>
  </table>
</div>
<paginador
  [listedPages]="uploadListedPages"
  [firstItemOnPage]="uploadFirstItemOnPage"
  [lastItemOnPage]="uploadLastItemOnPage"
  [totalPages]="uploadTotalPages"
  [totalItems]="uploadTotalItems"
  [currentPage]="uploadCurrentPage"
  [itemsPerPage]="[10, 25, 50, 100, 200]"
  (onSearch)="loadFilesPaged($event[0], $event[1])"
></paginador>
